module.exports = __webpack_public_path__ + "static/media/burrito_blanket.d88760ae.jpg";